import React from 'react'
import { base_url } from '../Components/Api/Api';

const NotificationConfig = () => {

    window.najvaUserSubscribed = function (najva_user_token) {
        if (localStorage.getItem('api_key') != null) {
            const Data = {
                'webpush_id': najva_user_token
            };
            base_url.post('pwa_pushid', Data)

        } else {
            localStorage.setItem('gcm_id', najva_user_token)
        }
    }
}

export default NotificationConfig;